export class Ticker {
    private internal: ReturnType<typeof setInterval> | undefined = undefined

    constructor(private periodInMs: number, private onTick: () => Promise<void> | void) {}

    public start(overridePeriodInMs?: number) {
        this.stop()
        this.internal = setInterval(this.onTick, overridePeriodInMs ?? this.periodInMs)
    }

    public stop() {
        clearInterval(this.internal)
        this.internal = undefined
    }
}
